export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
	verifyBackupEmailAddress(state: any, url: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get(url)
				.then((res) => resolve(res.status))
				.catch((err) => reject(err));
		});
	},

	resendBackupEmailVerificationNotification() {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/user/backup-email/verify/notification')
				.then((res) => resolve(res.status))
				.catch((err) => reject(err));
		});
	}
};
